import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { getUser } from 'src/utils/Common';
import {Typography,Grid,} from '@material-ui/core';
import {text} from "src/modules/languages/index"
const useStyles = makeStyles((theme) => ({
  root: {},
  summaryButton: {
    backgroundColor: theme.palette.common.white
  },
  barChartIcon: {
    marginRight: theme.spacing(1)
  },
  image: {
    width: '100%',
    maxHeight: 400
  }
}));

function Header({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  return (
    <div  {...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="center"
        container
        justifyContent="space-between"
        spacing={3}
      >
        <Grid
          item
          md={6}
          xs={12}
        >        
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            {text("iyi_gunler")},
            {' '}
            {SessionUser.FirstName} {SessionUser.LastName}
          </Typography>
          <Typography
            gutterBottom
            variant="subtitle1"
          >
            {"İşlemleriniz Aşağıdaki Gibidir!..."}
          </Typography>         
        </Grid>        
      </Grid>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;